import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    SET_USER: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/SET_USER'),
    CODE_DETAILS_REQUEST: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/CODE_DETAILS_REQUEST'),
    CODE_DETAILS_SUCCESS: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/CODE_DETAILS_SUCCESS'),
    ACTIVATE_CODE: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/ACTIVATE_CODE'),
    CODE_ACTIVATION_SUCCESS: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/CODE_ACTIVATION_SUCCESS'),
    SET_NEW_PLAN_INFO: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/SET_NEW_PLAN_INFO'),
    PLAN_CHANGE_INFO_REQUEST: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/PLAN_CHANGE_INFO_REQUEST'),
    PLAN_CHANGE_INFO_SUCCESS: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/PLAN_CHANGE_INFO_SUCCESS'),
    STOP_PROCESSING: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/STOP_PROCESSING'),
    ERROR: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/ERROR'),
    CLEAR_PLAN_CHANGE_INFO: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/CLEAR_PLAN_CHANGE_INFO'),
    CLEAR_DATA: createAction('GLOBAL/ORGANIZATION_ACTIVATION_CODES/CLEAR_DATA'),
};
export const initialState = Map({
    user: null,
    codeDetails: null,
    isCodeActivated: false,
    newPlanInfo: null,
    planChangeInfo: null,
    isProcessing: false,
    error: null,
});
const reducer = handleActions({
    [actions.SET_USER]: (state, action) => state.set('user', action.payload),
    [actions.CODE_DETAILS_REQUEST]: (state) => state.set('isProcessing', true),
    [actions.CODE_DETAILS_SUCCESS]: (state, action) => state.set('isProcessing', false).set('codeDetails', action.payload),
    [actions.ACTIVATE_CODE]: (state) => state.set('isProcessing', true),
    [actions.CODE_ACTIVATION_SUCCESS]: (state) => state.set('isCodeActivated', true).set('isProcessing', false),
    [actions.SET_NEW_PLAN_INFO]: (state, action) => state.set('newPlanInfo', action.payload),
    [actions.PLAN_CHANGE_INFO_REQUEST]: (state) => state.set('isProcessing', true),
    [actions.PLAN_CHANGE_INFO_SUCCESS]: (state, action) => state.set('planChangeInfo', action.payload),
    [actions.STOP_PROCESSING]: (state) => state.set('isProcessing', false),
    [actions.ERROR]: (state, action) => state.set('isProcessing', false).set('error', action.payload),
    [actions.CLEAR_PLAN_CHANGE_INFO]: (state) => state.set('planChangeInfo', null),
    [actions.CLEAR_DATA]: () => initialState,
}, initialState);
export default reducer;
